<template>
  <div>
    <template v-for="(cart, i) in carts">
      <div v-bind:key="i" v-bind:class="i != carts.length - 1 ? `mb-8` : ``">
        <div class="d-flex cursor-pointer" @click="openModal(i)">
          <div class="d-flex flex-column flex-grow-1 font-weight-bold">
            <span class="text-dark mb-1 font-size-lg">
              {{ cart.product.product.productName }}
            </span>
            <span class="text-muted font-size-sm">
              {{ getProductVariant(cart.product) }}
            </span>
          </div>
          <span
            v-if="cart.discount > 0"
            class="text-dark mb-1 font-size-sm text-decoration-line-through"
          >
            {{ setRupiah(cart.price) }}
          </span>
          <span class="font-weight-bold text-dark mb-1 font-size-lg ml-2">
            {{ setRupiah(cart.price - cart.discount) }}
          </span>
        </div>
        <div class="d-flex align-items-center mt-3">
          <div class="d-flex flex-column flex-grow-1">
            <div v-if="cart.product.product.isMembership == false">
              <b-button
                class="btn-icon mr-2"
                variant="light-success"
                size="xs"
                @click="decrease(cart)"
                :disabled="cart.product.product.isMembership != false"
              >
                <i class="ki ki-minus icon-sm"></i>
              </b-button>
              <span class="font-weight-bolder">
                {{ numberFormat(cart.quantity) }}
              </span>
              <b-button
                class="btn-icon ml-2"
                variant="light-success"
                size="xs"
                @click="increase(cart)"
                :disabled="cart.product.product.isMembership != false"
              >
                <i class="ki ki-plus icon-sm"></i>
              </b-button>
            </div>
          </div>
          <b-button
            class="btn-icon"
            variant="light-danger"
            size="xs"
            @click="remove(i)"
          >
            <i class="flaticon-delete icon-sm"></i>
          </b-button>
        </div>
      </div>
    </template>

    <b-modal
      v-model="modal.show"
      :title="modal.cart?.product?.product?.productName"
      :no-close-on-backdrop="true"
      size="md"
    >
      <div class="d-flex justify-content-between flex-column h-100">
        <div class="h-100 mb-4">
          <div class="d-flex flex-column">
            <span class="font-weight-bolder text-dark-75 font-size-h2 m-0 pb-1">
              {{ setRupiah(modal.price) }}
            </span>
          </div>
        </div>
        <InputMoney
          label="Ada diskon ?"
          v-model="modal.discount"
          :useHorizontal="false"
        />
        <div class="d-flex flex-column">
          <b-form-group
            v-if="!modal.cart?.product?.product?.isMembership"
            label="Kuantiti :"
            v-slot="{ ariaDescribedby }"
          >
            <b-input-group :aria-describedby="ariaDescribedby">
              <b-input-group-prepend>
                <b-button variant="outline-success" @click="modalDecrease">
                  <i class="ki ki-minus"></i>
                </b-button>
              </b-input-group-prepend>

              <b-form-input
                v-model="modal.quantity"
                type="number"
                min="1"
                class="border-success text-center font-weight-bolder"
                @input="calculateModalPrice"
              />

              <b-input-group-append>
                <b-button variant="outline-success" @click="modalIncrease">
                  <i class="ki ki-plus"></i>
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>

          <b-form-group
            v-for="(variant, indexVariant) in modal.cart?.product?.variants"
            v-bind:key="indexVariant"
            :label="`${variant.label} :`"
            :class="
              modal.cart?.product?.variants?.length - 1 == indexVariant
                ? `m-0 mb-2`
                : ``
            "
          >
            <b-button
              v-for="(detail, indexDetail) in variant.details"
              v-bind:key="indexDetail"
              :variant="detail.selectionDefault ? `success` : `outline-success`"
              size="sm"
              class="mr-2 mb-2"
              @click="changeVariant(indexVariant, indexDetail)"
            >
              {{ detail.label }}
            </b-button>
          </b-form-group>
        </div>
      </div>
      <template #modal-footer>
        <b-button
          variant="primary"
          block
          class="font-weight-bolder font-size-sm"
          @click="saveModal"
        >
          Simpan Perubahan
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { SET_CART } from "@/core/services/store/pos.module.js";
import { setRupiah, numberFormat } from "@/core/utils";

export default {
  props: {
    carts: Array,
  },
  data: () => ({
    modal: {
      show: false,
      index: -1,
      cart: null,
      quantity: 1,
      discount: 0,
      price: 0,
    },
  }),
  methods: {
    setRupiah,
    numberFormat,
    openModal(index) {
      const self = this;
      const cart = self.carts[index];
      if (cart == null) return;

      // Deep-clone supaya perubahan varian/kuantiti di dalam dialog tidak langsung
      // mengubah baris keranjang sebelum ditekan "Simpan Perubahan".
      self.modal.cart = JSON.parse(JSON.stringify(cart));
      self.modal.index = index;
      self.modal.quantity = Number(cart.quantity) || 1;
      self.modal.discount = Number(cart.discount) || 0;
      self.calculateModalPrice();
      self.modal.show = true;
    },
    modalDecrease() {
      const self = this;
      if (self.modal.cart.product.product.isMembership != false) return;
      if (self.modal.quantity > 1) {
        self.modal.quantity -= 1;
        self.calculateModalPrice();
      }
    },
    modalIncrease() {
      const self = this;
      const product = self.modal.cart.product;
      if (product.product.isMembership != false) return;
      if (product.manageStock == true) {
        if ((product.stock || 0) <= 0) {
          self.$message.warning({
            zIndex: 10000,
            message: "Yah, stok habis",
          });
          return;
        } else if (Number(self.modal.quantity) >= product.stock) {
          self.$message.warning({
            zIndex: 10000,
            message: `Yah, produk ini hanya punya stok sebanyak ${product.stock}`,
          });
          return;
        }
      }

      self.modal.quantity = (Number(self.modal.quantity) || 0) + 1;
      self.calculateModalPrice();
    },
    changeVariant(indexVariant, indexDetail) {
      const self = this;

      self.modal.cart.product.variants[indexVariant].details.forEach((item) => {
        item.selectionDefault = false;
      });
      self.modal.cart.product.variants[indexVariant].details[
        indexDetail
      ].selectionDefault = true;
      self.calculateModalPrice();
    },
    calculateModalPrice() {
      const self = this;
      const product = self.modal.cart.product;

      self.modal.price = product.regularPrice;
      if (product.variants != null) {
        product.variants.forEach((variant) => {
          variant.details.forEach((detail) => {
            if (detail.selectionDefault) self.modal.price += detail.priceLevel;
          });
        });
      }

      // Harga tetap GROSS — diskon dipotong sekali saja saat ditampilkan di
      // keranjang/ringkasan dan di backend.
      self.modal.price *= Number(self.modal.quantity) || 0;
    },
    saveModal() {
      const self = this;
      const product = self.modal.cart.product;

      if (product.variants != null) {
        const missing = product.variants.find(
          (variant) =>
            !variant.details.some((detail) => detail.selectionDefault)
        );
        if (missing != null) {
          self.$message.warning({
            zIndex: 10000,
            message: `Maaf, variant ${missing.label} dipilih dulu ya`,
          });
          return;
        }
      }

      // Kuantiti dari input type="number" bisa berupa string → paksa jadi angka
      // (min 1), lalu batasi ke stok untuk produk yang mengelola stok.
      let quantity = Number(self.modal.quantity) || 1;
      if (quantity < 1) quantity = 1;
      if (product.manageStock == true && quantity > product.stock)
        quantity = product.stock;

      const unitPrice =
        self.modal.quantity > 0
          ? self.modal.price / self.modal.quantity
          : self.modal.price;
      const price = unitPrice * quantity;

      // Jaga diskon manual di rentang [0, harga baris] supaya total tidak minus.
      let discount = Number(self.modal.discount) || 0;
      if (discount < 0) discount = 0;
      if (discount > price) discount = price;

      const index = self.modal.index;
      const variantKey = self.getProductVariant(product);

      // Kalau varian diubah jadi sama dengan baris lain, gabungkan supaya produk
      // + varian yang identik tidak muncul sebagai dua baris.
      const duplicate = self.carts.findIndex(
        (x, i) =>
          i != index &&
          x.product.id == product.id &&
          self.getProductVariant(x.product) == variantKey
      );

      if (duplicate >= 0) {
        const line = self.carts[duplicate];
        line.quantity = (Number(line.quantity) || 0) + quantity;
        if (product.manageStock == true && line.quantity > product.stock)
          line.quantity = product.stock;
        line.price = unitPrice * line.quantity;
        line.discount = Math.min(
          Math.max((Number(line.discount) || 0) + discount, 0),
          line.price
        );
        self.carts.splice(index, 1);
      } else {
        const line = self.carts[index];
        line.product = product;
        line.quantity = quantity;
        line.price = price;
        line.discount = discount;
      }

      self.$store.dispatch(SET_CART, self.carts);
      self.modal.show = false;
    },
    getProductVariant(product) {
      let labels = [];

      if (product.variants == null || product.variants.length == 0) {
        return "";
      } else {
        product.variants.forEach((variant) => {
          variant.details.forEach((detail) => {
            if (detail.selectionDefault) labels.push(detail.label);
          });
        });

        return labels.join(", ");
      }
    },
    decrease(cart) {
      const self = this;
      if (cart.product.product.isMembership != false) return;
      if (cart.quantity > 1) {
        cart.quantity -= 1;
        self.calculatePrice(cart);
      }
    },
    increase(cart) {
      const self = this;
      if (cart.product.product.isMembership != false) return;
      if (cart.product.manageStock == true) {
        if ((cart.product.stock || 0) <= 0) {
          self.$message.warning({
            zIndex: 10000,
            message: "Yah, stok habis",
          });
          return;
        } else if (Number(cart.quantity) >= cart.product.stock) {
          self.$message.warning({
            zIndex: 10000,
            message: `Yah, produk ini hanya punya stok sebanyak ${cart.product.stock}`,
          });
          return;
        }
      }

      cart.quantity = (Number(cart.quantity) || 0) + 1;
      self.calculatePrice(cart);
    },
    remove(index) {
      const self = this;
      self.carts.splice(index, 1);
      self.$store.dispatch(SET_CART, self.carts);
    },
    calculatePrice(cart) {
      cart.price = cart.product.regularPrice;
      if (cart.product.variants != null) {
        cart.product.variants.forEach((variant) => {
          variant.details.forEach((detail) => {
            if (detail.selectionDefault) cart.price += detail.priceLevel;
          });
        });
      }

      cart.price *= cart.quantity;

      // Re-clamp the discount to [0, line price] whenever the quantity changes,
      // otherwise lowering the quantity leaves a discount larger than the line
      // price and the order total goes negative.
      cart.discount = Math.min(
        Math.max(Number(cart.discount) || 0, 0),
        cart.price
      );
    },
  },
};
</script>
